import React from "react";
import { motion } from "framer-motion";
import { aboutSpans, timeline, designer } from "../data/portfolio";

export const AboutSection = () => {
  return (
    <section
      id="about"
      className="section-pad relative overflow-hidden"
      data-testid="about-section"
    >
      

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="md:sticky md:top-32"
            >
              <div className="eyebrow mb-6">— About</div>
              <h2 className="font-display font-light leading-[0.95] tracking-tight text-3xl md:text-4xl text-[#0E1A2B] mb-8">
                {designer.name.split(" ")[0]}, in her own words.
              </h2>
              <p className="text-[#6E7583] leading-relaxed">
                Mumbai-based. Five years across <span className="text-[#0E1A2B]">PropTech, FinTech, Health-tech, Marketplace and B2B</span>.
                Convinced that a product that technically works but still feels wrong is a bug worth fixing.
              </p>
            </motion.div>
          </div>

          <div className="col-span-12 md:col-span-8 md:pl-8 lg:pl-16">
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="leading-relaxed text-lg md:text-xl text-[#0E1A2B] mb-12 max-w-2xl"
              data-testid="about-paragraph"
            >
              {aboutSpans.map((s, i) => (
                <span
                  key={i}
                  className={s.accent ? "text-[#E5326A]" : ""}
                >
                  {s.text}
                </span>
              ))}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.1 }}
              className="mb-14 max-w-2xl border-l border-[#E5326A]/40 pl-6 md:pl-8 flex flex-col gap-4 text-[#0E1A2B] text-base md:text-lg leading-relaxed"
              data-testid="about-collaboration"
            >
              <p>
                I design inside the same repo the team ships from, Figma variables mapped to engineering tokens, so specs stop getting lost in translation and reviews argue about the decision, not the padding.
              </p>
              <p>
                Critique in my teams runs weekly on three questions: <span className="text-[#E5326A]">what's the decision this screen makes</span>, what did you reject, and what would you delete first. We leave with smaller designs, not longer ones.
              </p>
              <p>
                I've mentored two junior designers into their first product-owned surfaces, one now leads the Unischolars consideration funnel, a piece of the product they weren't running six months earlier.
              </p>
            </motion.div>

            <div className="relative pl-8 md:pl-12">
              <div
                aria-hidden
                className="absolute left-2 md:left-4 top-2 bottom-2 border-l border-dashed border-[#E5326A]/50"
              />
              <div className="eyebrow mb-10">— A short timeline</div>

              <ul className="flex flex-col gap-8" data-testid="about-timeline">
                {timeline.map((t, i) => (
                  <motion.li
                    key={t.year}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: i * 0.08 }}
                    className="relative"
                  >
                    <span
                      aria-hidden
                      className="absolute -left-[30px] md:-left-[38px] top-3 w-3 h-3 rounded-full bg-[#E5326A]"
                    />
                    <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-8">
                      <span className="font-numeric text-3xl md:text-4xl text-[#0E1A2B] font-light">
                        {t.year}
                        {t.ongoing && (
                          <span className="ml-2 text-base md:text-lg text-[#6E7583] italic align-baseline font-display">
                            — present
                          </span>
                        )}
                      </span>
                      <span className="text-[#6E7583] text-base md:text-lg">
                        {t.note}
                      </span>
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
